module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/keyboards-2425ef7b5d5262603742ca9126767e9a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/keyboards.svg
// module id = 33P3
// module chunks = 24